
import HesseFooter from '@/components/layout/Footer'
export default {
  name: 'FullscreenLayout',
  components: { HesseFooter },
}
